import {BaseService, QueryParams} from '../../../../core/abstracts/base-service.abstract';
import {Pageable} from '../../../../core/interfaces/base-service.interfaces';
import {StorageResponse} from '../model/storage-response.model';
import {PageableRequest} from '../../../../core/models/pagable.model';
import {Observable} from 'rxjs';
import {PageableResponse} from '../../../../core/models/page-response.model';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {StorageSearchFilterRequest} from '../model/storage-search-filter-request.model';

@Injectable({providedIn: 'root'})
export class VehicleStorageService extends BaseService implements Pageable<StorageResponse> {
  protected readonly endpoint: string = 'storages';

  constructor(private readonly httpClient: HttpClient) {
    super(httpClient);
  }

  getPage(
    pageable: PageableRequest,
    filters?: StorageSearchFilterRequest
  ): Observable<PageableResponse<StorageResponse>> {

    const params: QueryParams = {
      page: pageable.page,
      size: pageable.size,
      sort: pageable.sort,
      ...filters
    };

    return this.get<PageableResponse<StorageResponse>>('', params);
  }
}
